<template>
  <div class="sliderWrapper">
    <swiper
      :modules="modules"
      :slides-per-view="slidesPerView"
      :space-between="spaceBetween"
      :pagination="{ clickable: true }"
      navigation
      virtual
      @swiper="onSwiper"
    >
      <swiper-slide
        v-for="(imageSrc, index) in images"
        :key="index"
        :virtual-index="index"
      >
        <div class="cropper-square">
          <img-yay
            alt="Product"
            :src="imageSrc"
            :width="600"
            :height="600"
            crop="crop_top"
            :lazy="false"
            :classes="['cropped']"
            sizes="(min-width: 1530px) 718px, (min-width: 768px) 49vw, 98vw"
          />
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import '../composables/useBreakpoints'
import { Virtual, Pagination, Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { ref, watch } from 'vue'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import useBreakpoints from '../composables/useBreakpoints'

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    slidesPerView: { type: Number, default: 1 },
    spaceBetween: { type: Number, default: 20 },
    images: { type: Array, default: () => [] },
    resetSlideIndex: { type: Boolean },
  },

  setup(props) {
    // Hide Navigation on mobile
    let displayNav = ref('flex')
    let paginationBtnSize = ref('4px')
    const { screenType } = useBreakpoints()
    const imageSwiper = ref(null)
    const onSwiper = swiper => {
      imageSwiper.value = swiper
      if (screenType.value === 'xs') {
        displayNav.value = 'none'
        paginationBtnSize.value = '6px'
      }
    }
    watch(screenType, type => {
      if (type === 'xs') {
        displayNav.value = 'none'
        paginationBtnSize.value = '6px'
      } else {
        displayNav.value = 'flex'
        paginationBtnSize.value = '4px'
      }
    })
    watch(
      () => props.resetSlideIndex,
      () => {
        imageSwiper.value.slideTo(0, 0)
      },
    )

    return {
      modules: [Virtual, Pagination, Navigation],
      onSwiper,
      displayNav,
      paginationBtnSize,
    }
  },
}
</script>

<style scoped>
:deep(.swiper-pagination-bullet) {
  height: v-bind(paginationBtnSize);
  width: v-bind(paginationBtnSize);
}

:deep(.swiper-pagination-bullet-active) {
  @apply bg-gray-600;
}

:deep(.swiper-button-next) {
  color: rgba(75, 85, 99, var(--tw-text-opacity));
  display: v-bind(displayNav);
}
:deep(.swiper-button-prev) {
  color: rgba(75, 85, 99, var(--tw-text-opacity));
  display: v-bind(displayNav);
}
:deep(.swiper-button-disabled) {
  opacity: 0;
}
</style>
